import styled from "styled-components";
import Modal from "@material-ui/core/Modal";

const ModalStyled = styled(Modal)`
  width: 100%;
  background-color: ${({withoutBgColor}) => withoutBgColor ? "none" : "#333" };
  overflow: auto;
  font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '400')};
  text-align: ${({alignText}) => (alignText ? alignText : '')};
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 1;
`;

const TextContainer = styled.div`
  background-color: #FFF;
  border-radius: 10px;
  margin: 20px;
  padding-top: 30px;
  padding: 20px;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

export {
    ModalStyled,
    Container,
    TextContainer,
    Content,
};
